import usePublicDefinition from '../usePublicDefinition'

const EMPTY = { forms: [], fields: [], activities: [], outputs: [], targetgroups: [], subTargetgroups: {}, options: {} }

/**
 * De definitie van één openbaar registratieformulier, via `getPublicEventForm`.
 * De pagina las EventForms, EventFields, Activities, Outputs, Stakeholders,
 * SubTargetgroups en MultipleQuestionOptions tot 2026-11-04 zelf.
 *
 * @param {{client: string, eventId: string}} link
 * @returns {{data: import('../../StateManagment/PublicEventFormContext').PublicEventFormData|null, error: {code?: string, message?: string}|null}}
 */
const usePublicEventForm = ({ client, eventId }) => usePublicDefinition(
    'getPublicEventForm',
    client && eventId ? { client, eventId } : null,
    EMPTY
)

export default usePublicEventForm
